package com.macrofocus.common.format

import com.macrofocus.common.date.CPTimeZone
import com.macrofocus.common.locale.CPLocale

/**
 * The formats of the JVM FormatFactory, implemented by the [PortableFormats] (English, in the time zone of the
 * browser).
 */
actual open class FormatFactory : FormatFactoryCommon {
    actual fun createDecimalFormat(): CPFormat<Any?> = PortableFormats.decimalFormat()

    actual companion object {
        actual val instance: FormatFactory = FormatFactory()
    }

    actual override fun createDecimalFormat(fractionDigits: Int, pre: String?, post: String?, rounding: Double, factor: Double): CPFormat<Any?> =
        PortableFormats.decimalFormat(fractionDigits, pre, post, rounding, factor)

    actual override fun createIntegerFormat(pre: String?, post: String?, rounding: Double): CPFormat<Any?> =
        PortableFormats.integerFormat(pre, post, rounding)

    actual override fun createPercentDecimalFormat(fractionDigits: Int, rounding: Double): CPFormat<Any?> =
        PortableFormats.percentFormat(fractionDigits, rounding)

    actual fun createDateFormat(): CPFormat<Any?> = PortableFormats.dateFormat(PortableFormats.DATE, ::utcOffsetMinutes)

    actual fun createDateFormat(pattern: String?): CPFormat<Any?> = PortableFormats.dateFormat(pattern, ::utcOffsetMinutes)

    // Only the English names
    actual fun createDateFormat(pattern: String, locale: CPLocale?): CPFormat<Any?> = PortableFormats.dateFormat(pattern, ::utcOffsetMinutes)

    // Only the time zone of the browser
    actual fun createDateFormat(pattern: String, locale: CPLocale?, zone: CPTimeZone?): CPFormat<Any?> =
        PortableFormats.dateFormat(pattern, ::utcOffsetMinutes)

    actual fun createDateTimeFormat(): CPFormat<Any?> = PortableFormats.dateFormat(PortableFormats.DATE_TIME, ::utcOffsetMinutes)

    actual fun createDateOrDateTimeFormat(): CPFormat<Any?> = PortableFormats.dateOrDateTimeFormat(::utcOffsetMinutes)

    actual fun createNumberFormat(pattern: String?): CPFormat<Any?> = PortableFormats.numberFormat(pattern)
}

/** The offset of the time zone of the browser from UTC at [millis] since the epoch, in minutes. */
private fun utcOffsetMinutes(millis: Long): Int {
    val time = millis.toDouble()
    return -(js("new Date(time).getTimezoneOffset()") as Int)
}
